export default "__VITE_ASSET__Cgv1xYLq__"